import { SupportEnvironmentInterface } from '../../interfaces/support/support-environment-interface';

export class SupportEnvironmentModel implements SupportEnvironmentInterface {
  email: string = '';
  phone: string = '';

  constructor(init?: Partial<SupportEnvironmentModel>) {
    Object.assign(this, init);
  }
}
